import { render, staticRenderFns } from "./StopSmoking.vue?vue&type=template&id=2250b636&scoped=true&"
import script from "./StopSmoking.vue?vue&type=script&lang=js&"
export * from "./StopSmoking.vue?vue&type=script&lang=js&"
import style0 from "./StopSmoking.vue?vue&type=style&index=0&id=2250b636&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2250b636",
  null
  
)

export default component.exports